export default __webpack_public_path__ + "static/simon-9852e32598a6b13304d9c481e7b5d408.png";